import axios from './axios';

export default {
  sendSms(phone) {
    return axios.POSTForm('/rest/sendSms', { phoneNo: phone });
  },
  getOrders(params) {
    return axios.GET('/rest/query', params);
  },
  getOrder(orderNo) {
    return axios.GET('/rest/getOrder', { orderNo });
  },
  orderDelivered(orderNo) {
    return axios.POSTForm('/rest/delivered', { orderNo });
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js